const Training = () => import('../views/training');


export default [
    { path: '/training', component: Training },
]